import { PRIO } from '../../../../constants';
import { ProjectId } from '../../../../models/Types';

/** Last known value of the setting SharedMailbox_AutoMarkAsRead per project */
export const SET_PROJECT_AUTO_MARK_AS_READ =
  PRIO + 'SET_PROJECT_AUTO_MARK_AS_READ';

export const setProjectAutoMarkAsRead = (
  isEnabledByProjectId: Record<ProjectId, boolean>
) => ({
  type: SET_PROJECT_AUTO_MARK_AS_READ,
  payload: { isEnabledByProjectId },
});
